<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getDeliveryQualityInspections"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-delivery-quality-inspection-no" label-cols-sm="4" label-cols-lg="3" label="Delivery Quality Inspection Number" label-for="filter-delivery-quality-inspection-no" size="sm" :model.sync="filter.deliveryQualityInspectionNo" />
					<app-input-combobox-autocomplete :options="deliveryInstructions" optionsLabel="diNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Delivery Instruction" id="filter-" size="sm" :model.sync="filter.deliveryInstructionId" @input="getDeliveryInstructions" @focus="getDeliveryInstructions" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="DeliveryQualityInspectionStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Delivery Quality Inspection Status" id="filter-" size="sm" :model.sync="filter.deliveryQualityInspectionStatusId" @input="getDeliveryQualityInspectionStatuss" @focus="getDeliveryQualityInspectionStatuss" />

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getDeliveryQualityInspections"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Delivery Quality Inspection</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown v-if="isShowDefaultFeatures" text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/deliveryqualityinspection/DeliveryQualityInspection.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Start Scan</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Start Scan</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="isShowDefaultFeatures" class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
					
					<b-overlay v-if="isShowDeleteButton && isShowDefaultFeatures"
							   :show="isDeleteBusy"
							   rounded
							   opacity="0.6"
							   spinner-small
							   spinner-variant="primary"
							   class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-deliveryqualityinspection" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="deliveryQualityInspections" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="deliveryQualityInspections.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th stacked-heading="Select All">
							<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false) & isShowDefaultFeatures" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
						</b-th>
						<b-th stacked-heading="Delivery Quality Inspection Number" class="table-filter">
							<b-form-input id="input-delivery-quality-inspection-no-table" @input="getDeliveryQualityInspectionsWithoutLoading" v-model="filter.deliveryQualityInspectionNo" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Delivery Instruction" class="table-filter">
							<v-select append-to-body label="diNumber" :options="deliveryInstructions" :value="filter.deliveryInstructionId" :reduce="item => item.id" v-model="filter.deliveryInstructionId" :filterable="true" @input="getDeliveryQualityInspectionsWithoutLoading" @search="getDeliveryInstructions"></v-select>
						</b-th>
						<b-th stacked-heading="Delivery Instruction Customer" class="table-filter">
						</b-th>
						<b-th></b-th>
						<b-th stacked-heading="Delivery Quality Inspection Status" class="table-filter">
							<v-select append-to-body label="name" :options="DeliveryQualityInspectionStatuss" :value="filter.deliveryQualityInspectionStatusId" :reduce="item => item.id" v-model="filter.deliveryQualityInspectionStatusId" :filterable="true" @input="getDeliveryQualityInspectionsWithoutLoading" @search="getDeliveryQualityInspectionStatuss"></v-select>
						</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

				<template v-slot:cell(deliveryqualityinspectionno)="row">
						{{ row.item.deliveryQualityInspectionNo != null && row.item.deliveryQualityInspectionNo != "" ?
							(typeof row.item.productCode == 'string') ?
								row.item.deliveryQualityInspectionNo.slice(0, 30) + (row.item.deliveryQualityInspectionNo.length > 30 ? "..." : "" ) : row.item.deliveryQualityInspectionNo : "" }}
				</template>

			<template v-slot:cell(deliveryInstruction)="row">
				<a @click="showDetail(row.item)" class="a-link-detail">
					{{ row.item.deliveryInstruction != null ?
						(typeof row.item.deliveryInstruction.diNumber == 'string') ?
							row.item.deliveryInstruction.diNumber.slice(0, 30) + (row.item.deliveryInstruction.diNumber.length > 30 ? "..." : "" ) : row.item.deliveryInstruction.diNumber : "" }}
				</a>
			</template>
			<template v-slot:cell(deliveryInstructionCustomer)="row">
					<div>{{ row.item.deliveryInstruction != null ? ((row.item.deliveryInstruction.diCustomer != null) ? row.item.deliveryInstruction.diCustomer.code : "") : "" }}</div>
			</template>
			<template v-slot:cell(deliveryInstructionDate)="row">
					<div>{{ row.item.deliveryInstruction.diDeliveryDate | moment("DD-MMM-YYYY HH:mm") }}</div>
			</template>
			<template v-slot:cell(deliveryQualityInspectionStatus)="row">
				
				<div class="two-item">
					<div>{{ row.item.deliveryQualityInspectionStatus != null ? row.item.deliveryQualityInspectionStatus.name : "" }}</div>
					<div :class="getRectangleClass(row.item.deliveryQualityInspectionStatus.code)">&nbsp;</div>
				</div>
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2" v-if="isShowDefaultFeatures">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="delivery-quality-inspection-no" label-cols-lg="12"  label="Delivery Quality Inspection Number" label-for="input-delivery-quality-inspection-no" size="sm" :model="row.item.deliveryQualityInspectionNo"   :isEditable="false" :isUpdatable="true" />
						<app-input-datetimepicker id="delivery-quality-inspection-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model="row.item.deliveryInstruction.diDeliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.deliveryQualityInspectionStatusId" label="Delivery Quality Inspection Status" :selected="row.item.deliveryQualityInspectionStatus != null ? row.item.deliveryQualityInspectionStatus.name : ''" :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(deliveryQualityInspectionsPaging != null ? deliveryQualityInspectionsPaging.dataCount : 0)"
									:per-page="(deliveryQualityInspectionsPaging != null ? deliveryQualityInspectionsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-deliveryqualityinspection.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-deliveryqualityinspection.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-deliveryqualityinspection.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
	.two-item {
		display: flex;
		padding: 10px;
		justify-content: space-between;
		align-items: center;
	}
	.rectangle {
		width: 30px;
		height: 30px;
	}
	.rectangle-danger {
		background-color: #DC3545;
	}
	.rectangle-warning {
		background-color: #FFC107;
	}
	.rectangle-success {
		background-color: #28A745;
	}
</style>
<script>
import DeliveryQualityInspection from '@/models/DeliveryQualityInspection/DeliveryQualityInspection';
import DeliveryQualityInspectionList from '@/models/DeliveryQualityInspection/DeliveryQualityInspectionList';
import DeliveryQualityInspectionFilter from '@/filters/DeliveryQualityInspection/DeliveryQualityInspectionFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputTextbox from '@/components/AppInputTextbox';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import DeliveryQualityInspectionStatusFilter from '@/filters/DeliveryQualityInspectionStatus/DeliveryQualityInspectionStatusFilter';
import DeliveryQualityInspectionStatus from '@/models/DeliveryQualityInspectionStatus/DeliveryQualityInspectionStatus';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import DeliveryQualityInspectionDetailFilter from '@/filters/DeliveryQualityInspection/DeliveryQualityInspectionDetailFilter';
import DeliveryQualityInspectionDetail from '@/models/DeliveryQualityInspection/DeliveryQualityInspectionDetail';
import DeliveryInstructionDeliveryCardFilter from '@/filters/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCardFilter';
import DeliveryInstructionDeliveryCard from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCard';
import QcStatusFilter from '@/filters/QcStatus/QcStatusFilter';
import QcStatus from '@/models/QcStatus/QcStatus';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';

export default {
	components : {
		DeliveryQualityInspection, 
		DeliveryQualityInspectionList, 
		DeliveryQualityInspectionFilter, 
		AppLabel,
		AppInputTextarea,
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
		AppInputDatetimepicker,
	},
	data() {
		return {
			selectAll:false,
			isShowDefaultFeatures:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"deliveryQualityInspectionNo": {}, "class" : "th-delivery-quality-inspection-no d-stack-none", "label" : "Delivery Quality Inspection Number", key: 'deliveryQualityInspectionNo', sortable: true}, 
				{"deliveryInstruction": {}, "class" : "th-delivery-instruction first-child", "label" : "Delivery Instruction", key: 'deliveryInstruction', sortable: true}, 
				{"deliveryInstructionCustomer": {}, "class" : "th-delivery-instruction-customer", "label" : "Customer", key: 'deliveryInstructionCustomer', sortable: true}, 
				{"deliveryDate": {}, "class" : "th-delivery-instruction-delivery-date d-stack-none", "label" : "Delivery Date", key: 'deliveryInstructionDate', sortable: false}, 
				{"deliveryQualityInspectionStatus": {}, "class" : "th-delivery-quality-inspection-status last-child", "label" : "Delivery Quality Inspection Status", key: 'deliveryQualityInspectionStatus', sortable: true}, 
				
				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			deliveryQualityInspections: [],
			deliveryQualityInspectionsPaging: {},
			deliveryInstructions : [],
			DeliveryQualityInspectionStatuss : [],
			deliveryQualityInspectionDetails : [],
			deliveryQualityInspectionCards : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: true,
			
		}
	},	methods : {
		
		showDetail(item){
			this.$router.push({ name: this.getTargetView(item), params : { id: item.id } });
		},
		getTargetView(item){
			var targetView = item.deliveryQualityInspectionStatus!=null && (item.deliveryQualityInspectionStatus.code.toUpperCase() == "OPEN" || item.deliveryQualityInspectionStatus.code.toUpperCase() == "IN_PROGRESS") ? 'deliveryqualityinspectionscan' : 'deliveryqualityinspectiondetail';
			// console.log(targetView.toLowerCase());
			return targetView.toLowerCase();
		},
		getRectangleClass(documentStatus) {
			documentStatus = documentStatus.toUpperCase();
			let cls = "rectangle";
			if(documentStatus == "DONE") {
				cls += " rectangle-success";
			} else if(documentStatus == "IN_PROGRESS" || documentStatus == "IN_PROGRESS_PRODUCTION" || documentStatus == "IN_PROGRESS_RFP") {
				cls += " rectangle-warning";
			} else {
				cls += " rectangle-danger";
			}

			return cls;
		}, 

		getDeliveryQualityInspections : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			DeliveryQualityInspection.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.deliveryQualityInspections = result.data
					this.deliveryQualityInspectionsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getDeliveryQualityInspectionsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			DeliveryQualityInspection.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.deliveryQualityInspections = result.data
					this.deliveryQualityInspectionsPaging = result
				}
			})
			.catch(error => {});
		},
		getDeliveryInstructions : async function(input) {
			let filter = new DeliveryInstructionFilter();
			if (input != undefined) {
				filter.diNumber = input;
			}

			if(this.filter.deliveryInstructionId != undefined && input == '') {
				filter.id = this.filter.deliveryInstructionId;
			}

			await DeliveryInstruction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructions = result.data
				}
			})
			.catch(error => {});
		},
		getDeliveryQualityInspectionStatuss : async function(input) {
			let filter = new DeliveryQualityInspectionStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await DeliveryQualityInspectionStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.DeliveryQualityInspectionStatuss = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new DeliveryQualityInspectionFilter();
			this.getDeliveryQualityInspections();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getDeliveryQualityInspections();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				DeliveryQualityInspection.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			DeliveryQualityInspection.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			DeliveryQualityInspection.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			DeliveryQualityInspection.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'deliveryqualityinspectionedit';
						if(this.isScannerMode) {
							createRoute = 'deliveryqualityinspectionscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			DeliveryQualityInspection.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'deliveryqualityinspectionedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			DeliveryQualityInspection.deleteData(this, id).then(result => {
				if (result)
				{
					this.getDeliveryQualityInspections();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				DeliveryQualityInspection.deleteMultipleData(this).then(result => {
					this.getDeliveryQualityInspections();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableDeliveryQualityInspectionParent = document.getElementById('table-list-deliveryqualityinspection').parentNode;
			tableDeliveryQualityInspectionParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableDeliveryQualityInspectionParent.scrollWidth - tableDeliveryQualityInspectionParent.offsetWidth) == Math.ceil(tableDeliveryQualityInspectionParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableDeliveryQualityInspectionParent = document.getElementById('table-list-deliveryqualityinspection').parentNode;
			tableDeliveryQualityInspectionParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableDeliveryQualityInspectionParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new DeliveryQualityInspectionFilter();
		this.getDeliveryInstructions()
		this.getDeliveryQualityInspectionStatuss()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Delivery Quality Inspection"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getDeliveryQualityInspections();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getDeliveryQualityInspections();
			}
		},
		sortDesc: {
			handler: function() {
				this.getDeliveryQualityInspections();
			}
		},
		currentPage: {
			handler: function() {
				this.getDeliveryQualityInspections();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getDeliveryQualityInspections();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				DeliveryQualityInspection.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "deliveryqualityinspectionindex") {
					this.getDeliveryQualityInspectionsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "delivery_quality_inspection").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
